import { createContext, useContext} from 'react'

import { EnumNormalizedStructure } from '../../../../common/types/enums.options'

export type EnumOptionsContextType = {
  countryData: EnumNormalizedStructure[]
  nationalityData: EnumNormalizedStructure[]
  bodyTypeData: EnumNormalizedStructure[]
  religionData: EnumNormalizedStructure[]
  politicalBeliefData: EnumNormalizedStructure[]
  userInterestsData: (EnumNormalizedStructure & { 'category':string})[]
  loading: boolean
  error: string | null
}

export const ContextEnumOptions = createContext<EnumOptionsContextType | undefined>(undefined)

export const useEnumOptions = () => {
  const context = useContext(ContextEnumOptions)
  if (!context) {
    throw new Error('useEnumOptions must be used within a EnumOptionsProvider')
  }
  return context
}
